module.exports = __webpack_public_path__ + "img/project.0bec5fb3.png";